<template>
  <div id="index-practice-collect">
    <!-- 收藏集 -->
    <diy_table
      :loading="loading"
      :searchData="searchData"
      :tableMenu="tableMenu"
      :tableData="tableData"
      :tableButton="tableButton"
      :pageData="pageData"
      @initTable="initTable"
      @handleClick="handleClick"
    ></diy_table>

    <diy_dialog
      v-if="dialogData.flag"
      :title="dialogData.title"
      :width="dialogData.width"
      :dialogData="dialogData.dialogData"
      :buttonList="dialogData.buttonList"
      @colseDialog="colseDialog"
      @dialogOper="dialogOper"
    ></diy_dialog>
  </div>
</template>

<script>
import * as practiceData from "./js/practice.js";
export default {
  data() {
    return {
      loading: false,
      searchData: practiceData.getSearchData("err"),
      tableMenu: practiceData.getTableMenu("err"),
      tableData: [],
      tableButton: practiceData.getTableBUttonList("err"),
      pageData: {
        currentPage: 1, // 当前页数
        pageSize: 10, // 每页条数
        total: 20, // 总条目数
      },

      dialogData: {
        flag: false,
        title: "题库导入",
        width: "40%",
        tempData: {},
        dialogData: [],
        buttonList: [
          { text: "确定", active: "makesure_choose_import_type" },
          { text: "取消", active: "cancel" },
        ],
      },
      tempQuestion: {},
    };
  },
  methods: {
    async initTable(data) {
      this.loading = true;
      try {
        let requestData = {
          currentPage: data.pageData.currentPage,
          pageSize: data.pageData.pageSize,
          flag: "collect",
        };
        requestData = this.$baseData.array2json(data.searchData, requestData);
        let resultData = await this.$request({
          url: "/errCollect/getAllErrCollectList",
          method: "post",
          data: requestData,
        });
        this.tableData = resultData.tableData;
        this.pageData.total = resultData.total;
        setTimeout(() => {
          this.loading = false;
        }, 300);
      } catch (error) {
        this.$message.error(error.message);
        this.loading = false;
      }
    },
    async handleClick(data) {
      try {
        this.tempQuestion = JSON.parse(JSON.stringify(data.item));
        switch (data.active) {
          case "show":
            // 查看
            this.dialogData.title = "错题详情";
            this.dialogData.dialogData = [
              {
                type: "question-details",
                value: { qId: this.tempQuestion.id, type: "1" },
              },
            ];
            this.dialogData.buttonList = [{ text: "关闭", active: "cancel" }];
            this.dialogData.flag = true;
            break;
          case "remove":
            // 移除
            this.$confirm("是否从错题集中移除当前试题?", "提示", {
              confirmButtonText: "确定",
              cancelButtonText: "取消",
              type: "warning",
            })
              .then(async () => {
                try {
                  let resultData = await this.$request({
                    url: "/errCollect/removeErrCollectById",
                    method: "post",
                    data: { id: this.tempQuestion.id, flag: "collect" },
                  });
                  this.$message({
                    type: "success",
                    message: "操作成功!",
                  });
                  await this.initTable({
                    pageData: this.pageData,
                    searchData: this.searchData,
                  });
                } catch (error) {
                  this.$message({
                    message: error.message,
                    type: "warning",
                    duration: 1000,
                  });
                }
              })
              .catch(() => {
                this.$message({
                  type: "info",
                  message: "已取消",
                });
              });
            break;

          default:
            break;
        }
      } catch (error) {}
    },
    dialogOper(active) {},
    colseDialog() {
      this.dialogData.flag = false;
    },
  },
  async mounted() {
    await this.initTable({
      pageData: this.pageData,
      searchData: this.searchData,
    });
  },
};
</script>

<style lang="less" scoped>
#index-practice-collect {
  width: 100%;
  height: 100%;
}
</style>